import React from 'react';
import { Button, Label, Modal, Spinner, Textarea } from 'flowbite-react';
import { RxCross2 } from 'react-icons/rx';
import { UseMutationResult } from 'react-query';
import {
	ApplicationStatus,
	BaseAPIResponse,
	RequestForOptOutInput,
	RespondToOfferLetterInput,
	UIApplication,
	UIExtendedApplication,
} from 'types';

interface Props {
	application: UIApplication | UIExtendedApplication;
	isOpen: boolean;
	onClose: () => void;
	requestOptingOutOfApplicationProcessMutation?: UseMutationResult<BaseAPIResponse, Error, RequestForOptOutInput>;
	offerLetterResponseMutation?: UseMutationResult<BaseAPIResponse, Error, RespondToOfferLetterInput>;
	optOutReason: string;
	setOptOutReason: (reason: string) => void;
	fromOfferLetter?: boolean;
}

const OptOutModal = ({
	optOutReason,
	setOptOutReason,
	isOpen,
	onClose,
	requestOptingOutOfApplicationProcessMutation,
	application,
	fromOfferLetter,
	offerLetterResponseMutation,
}: Props) => {
	return (
		<div
			onClick={e => {
				e.stopPropagation();
			}}
		>
			<Modal
				onClick={e => {
					e.stopPropagation();
				}}
				position={'center'}
				show={isOpen}
				dismissible={true}
				onClose={onClose}
				size={'md'}
			>
				<Modal.Body className="relative flex flex-col gap-y-8 justify-center rounded-[8px] border border-solid dark:border-[#555770] dark:bg-[#1F2A37] p-8">
					<div>
						<p className="text-center dark:text-[#F2F2F5] font-inter text-[16px] font-[500] leading-[24px]">
							{fromOfferLetter
								? `Are you sure you want to reject the offer?`
								: `Are you sure you want to opt out of the interview process?`}
						</p>
						<div>
							<div className="block mt-[16px] mb-[8px]">
								<Label
									htmlFor="title"
									value={
										fromOfferLetter
											? `Please provide a reason for rejecting the offer.`
											: `Please provide a reason for opting out of the interview process.`
									}
									className="dark:text-[#FFF] font-inter text-[14px] font-[500] leading-[21px]"
								/>
								<span className="text-red-600">*</span>
							</div>

							<Textarea
								onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setOptOutReason(e.target.value)}
								onClick={e => {
									e.stopPropagation();
								}}
								placeholder="Write reason here ..."
								rows={4}
							/>
						</div>
						<div className="mt-[20px] flex items-center gap-[16px] justify-center">
							{fromOfferLetter && application?.status !== ApplicationStatus.CHANGED_OFFER_TERMS ? (
								<Button
									color="purplePlaced"
									disabled={offerLetterResponseMutation?.isLoading || !optOutReason}
									onClick={() => {
										offerLetterResponseMutation &&
											offerLetterResponseMutation.mutate({
												applicationId: application._id || '',
												action: 'Reject',
												remarks: optOutReason,
											});
									}}
								>
									{offerLetterResponseMutation?.isLoading ? <Spinner /> : 'Yes, I’m sure, reject'}
								</Button>
							) : (
								<Button
									color="purplePlaced"
									disabled={requestOptingOutOfApplicationProcessMutation?.isLoading || !optOutReason}
									onClick={() => {
										requestOptingOutOfApplicationProcessMutation &&
											requestOptingOutOfApplicationProcessMutation.mutate({
												applicationId: application._id || '',
												userId: application.user?._id || '',
												remarks: optOutReason,
											});
									}}
								>
									{requestOptingOutOfApplicationProcessMutation?.isLoading ? <Spinner /> : 'Yes, I’m sure'}
								</Button>
							)}

							<Button
								onClick={e => {
									e.stopPropagation();
									onClose();
								}}
								color="light"
							>
								No, Cancel
							</Button>
						</div>
					</div>
					<RxCross2
						onClick={e => {
							e.stopPropagation();
							onClose();
						}}
						className="absolute right-[10px] top-[10px] h-[20px] w-[20px] cursor-pointer text-[#9CA3AF]"
					/>
				</Modal.Body>
			</Modal>
		</div>
	);
};

export default OptOutModal;
